import { useState } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import SharedIDModal from "pages/Clients/sections/ClientHeros/SharedIDModal";
import { useTranslation } from "react-i18next";
import intro1 from "assets/images/clients/intros/macos/intros-macos-01.png";
import intro2 from "assets/images/clients/intros/macos/intros-macos-02.png";

function MacOSDesc() {
  const { t } = useTranslation();
  const [sharedOpen, setSharedOpen] = useState(false);

  return (
    <Card
      sx={{
        p: { xs: 2, md: 3 },
        mx: { xs: 2, lg: 3 },
        mt: 2,
        mb: 2,
        boxShadow: ({ boxShadows: { lg } }) => lg,
      }}
    >
      <MKTypography variant="h5" fontWeight="bold" mb={1}>
        {t("clients.macos.desc.title")}
      </MKTypography>

      <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <Grid item xs={12} md={5}>
          <Box
            component="img"
            src={intro1}
            alt="macOS intro step 1"
            sx={{
              width: "100%",
              display: "block",
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.300",
            }}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <MKTypography variant="h6" fontWeight="bold" mb={0.5}>
            {t("clients.macos.desc.standardTitle")}
          </MKTypography>
          <MKTypography variant="body2" color="text">
            {t("clients.macos.desc.standardBody")}
          </MKTypography>
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={5}>
          <Box
            component="img"
            src={intro2}
            alt="macOS intro step 2"
            sx={{
              width: "100%",
              display: "block",
              borderRadius: 1,
              border: "1px solid",
              borderColor: "grey.300",
            }}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <MKTypography variant="h6" fontWeight="bold" mb={0.5}>
            {t("clients.macos.desc.advancedTitle")}
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={1.5}>
            {t("clients.macos.desc.advancedBody")}
          </MKTypography>
          <MKButton
            variant="gradient"
            color="info"
            size="small"
            onClick={() => setSharedOpen(true)}
          >
            {t("clients.macos.desc.sharedIdButton")}
          </MKButton>
        </Grid>
      </Grid>
      <SharedIDModal open={sharedOpen} onClose={() => setSharedOpen(false)} />
    </Card>
  );
}

export default MacOSDesc;
